import React from "react";

import { percentage } from "lib/common";

import { getJob } from "lib/store/sentiment";

import { Button } from "@atsent/components";

import { Spinner } from "components/atom/Spinner";

import "./ProgressButton.scss";

export type ProgressButtonProps = {
  cx?: string;
  pid: number;
  curId: () => Promise<number>;
  setErrorToast: any;
  setToast: any;
  ls: {
    // localStorage
    key: string;
    type: "appStore" | "googlePlay";
  };
  onProcessEnd: any;
};

export type ProgressButtonState = {
  loading: boolean;
  select: number;
  currentFile: string[][] | null;
  progress: number;
  curState: "ready" | "hasFile" | "progress" | "complete";
  curInterval: any;
  projectId: number;
};

export class ProgressButton extends React.Component<
  ProgressButtonProps,
  ProgressButtonState
> {
  constructor(props: ProgressButtonProps) {
    super(props);

    this.state = {
      currentFile: null,
      loading: false,
      select: -1,
      progress: 10,
      curInterval: null,
      projectId: 0,
      curState: "ready",
    };

    this.setLoading = this.setLoading.bind(this);
    this.setProgress = this.setProgress.bind(this);
    this.setFile = this.setFile.bind(this);
    this.setCurrentFile = this.setCurrentFile.bind(this);
    this.setCurState = this.setCurState.bind(this);
    this.setSelect = this.setSelect.bind(this);

    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleDeleteBatch = this.handleDeleteBatch.bind(this);
    this.handleClickButton = this.handleClickButton.bind(this);
  }

  setLoading = (val: boolean) => this.setState((_) => ({ ..._, loading: val }));
  setProgress = (val: number) =>
    this.setState((_) => ({ ..._, progress: isNaN(val) ? 0 : val }));
  setFile = (val: any) => this.setState((_) => ({ ..._, file: val }));
  setCurrentFile = (val: any) =>
    this.setState((_) => ({
      ..._,
      currentFile: val,
    }));
  setSelect = (val: number) => this.setState((_) => ({ ..._, select: val }));
  setCurState = (val: "ready" | "hasFile" | "progress" | "complete") =>
    this.setState((_) => ({
      ..._,
      curState: val,
    }));
  setCurInterval = (val: any) =>
    this.setState((_) => ({ ..._, curInterval: val }));

  //refresh를 위해서 localstorage에 pid를 적어놓는다.
  handleClickButton = async () => {
    const { curId, ls, pid } = this.props;
    const id = await curId();

    if (id > 0) {
      let returnVal = JSON.parse(
        localStorage.getItem(ls.key) ?? `{"${pid}":{}}`
      );
      let curProject = returnVal[pid];
      console.log(curProject);
      if (!curProject) {
        curProject = {};
      }
      if (!curProject[ls.type]) {
        curProject = { [ls.type]: id };
      }
      localStorage.setItem(
        ls.key,
        JSON.stringify({
          ...returnVal,
          [pid]: { ...returnVal[pid], ...curProject },
        })
      );
      await this.handleRefresh(id);
    }
  };

  handleDeleteBatch = () => {
    const { pid, ls, onProcessEnd } = this.props;
    let returnVal: any = {};
    const batchData = localStorage.getItem(ls.key);
    if (!!batchData) {
      returnVal = JSON.parse(batchData);
    }
    if (
      Object(returnVal).hasOwnProperty(`${pid}`) &&
      !!returnVal[pid][ls.type]
    ) {
      delete returnVal[`${pid}`][ls.type];
    }
    localStorage.setItem(ls.key, JSON.stringify(returnVal));
    onProcessEnd();
  };

  handleRefresh = async (id: number) => {
    const {
      setLoading,
      setCurState,
      setProgress,
      setCurInterval,
      handleDeleteBatch,
    } = this;
    const { setErrorToast, pid } = this.props;
    const { curInterval } = this.state;
    try {
      const { total, done } = await getJob(pid, id);
      setLoading(true);
      setProgress(done / total);
      const interval = setInterval(async () => {
        setCurInterval(interval);
        const { status, total, done } = await getJob(pid, id);
        setProgress(done / total);
        if (status !== "IN_PROGRESS" && status !== "READY") {
          await clearInterval(interval);
          await setLoading(false);
          if (status === "DONE") {
            setCurState("complete");
            handleDeleteBatch();
          }
        }
      }, 2000);
    } catch (e) {
      clearInterval(curInterval);
      handleDeleteBatch();
      setErrorToast(e);
    }
  };

  componentDidMount() {
    const { handleRefresh } = this;
    const { pid, ls } = this.props;
    try {
      const curId = JSON.parse(localStorage.getItem(ls.key) ?? "")[`${pid}`];

      if (!!curId && !!curId[ls.type]) {
        handleRefresh(curId[ls.type]);
      }
    } catch (e) {
      localStorage.setItem(ls.key, `{"${pid}":{}}`);
    }
  }

  componentWillUnmount() {
    clearInterval(this.state.curInterval);
  }

  render() {
    const { handleClickButton } = this;
    const { cx } = this.props;
    const { loading, progress } = this.state;
    return loading ? (
      <Button cx={cx}>
        {progress > 0 ? (
          `${percentage(progress)}%`
        ) : (
          <Spinner bgColor={"black"} />
        )}
      </Button>
    ) : (
      <Button
        cx={cx}
        click={() => {
          handleClickButton();
        }}
      >
        연동하기
      </Button>
    );
  }
}
